export const environment = {
  production: false,
  // baseUrl: '/assets/mockapi',
  apiUrl: window['__API_URL'],
  licenseServer: 'https://smartworks4su.space',
  mqUrl: window['__MQ_URL'],
};
